import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ProductCategory } from "@/lib/category-service";
import ProductCategoryCard from "@/polymet/components/product-category-card";

interface ProductCategoryListProps {
  categoryId: string;
  categorySlug: string;
  categoryName: string;
  subCategoryId: string;
  subCategorySlug: string;
  subCategoryName: string;
  productCategories: ProductCategory[];
  title?: string;
  description?: string;
  className?: string;
}

export default function ProductCategoryList({
  categoryId,
  categorySlug,
  subCategoryId,
  subCategorySlug,
  subCategoryName,
  productCategories,
  title,
  description,
  className = "",
}: ProductCategoryListProps) {
  return (
    <Card className={`shadow-none ${className}`}>
      <CardHeader>
        <CardTitle className="text-2xl font-bold">
          {title || `${subCategoryName} Product Categories`}
        </CardTitle>
        {description && <p className="text-muted-foreground">{description}</p>}
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {productCategories.map((productCategory, index) => (
            <ProductCategoryCard
              key={productCategory.id}
              id={productCategory.id}
              categoryId={categoryId}
              categorySlug={categorySlug}
              subCategoryId={subCategoryId}
              subCategorySlug={subCategorySlug}
              slug={productCategory.slug}
              name={productCategory.name}
              description={productCategory.description || ''}
              image={productCategory.image_url || `/placeholder-product-category-${(index % 4) + 1}.jpg`}
              productCount={productCategory.product_count || 0}
            />
          ))}

          {productCategories.length === 0 && (
            <div className="text-center py-12 col-span-full">
              <p className="text-lg text-muted-foreground">
                No product categories found
              </p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
